/**
 * Đọc quyền cấp riêng của tài khoản từ session.
 *
 * Session mang `user.permissions` là một object `{"export_excel": true}`. Khoá
 * VẮNG MẶT nghĩa là KHÔNG có quyền — mọi quyền mặc định `false`, kể cả quyền
 * vừa thêm cho những tài khoản tạo từ trước.
 *
 * Đây chỉ là lớp hiển thị: ẩn một tab hay một nút chỉ giấu đường đi, quyết định
 * thật nằm ở middleware phía server (`be-express/src/middleware`). Đừng dùng
 * hàm này làm lớp bảo vệ duy nhất cho một dữ liệu nào.
 */

/** Danh mục quyền server trả về cho trang quản trị. */
export interface PermissionDefinition {
	key: string;
	label: string;
	description: string;
}

/**
 * Tài khoản có quyền `key` hay không.
 *
 * Chấp nhận `unknown` vì session có thể tới từ một bản server cũ hơn (không có
 * trường này) hoặc mang dữ liệu lạ; mọi trường hợp đó đều rơi về "không có
 * quyền" thay vì ném lỗi giữa lúc render.
 */
export function hasPermission(permissions: unknown, key: string): boolean {
	if (!permissions || typeof permissions !== "object" || Array.isArray(permissions)) return false;
	// Chỉ `true` mới là có quyền — chuỗi "true" hay số 1 không phải thứ server
	// từng ghi ra.
	return (permissions as Record<string, unknown>)[key] === true;
}
